export const cryptoskillPaymentsBData = [
  {
    id: 'moonpay-official-moonpay-commerce',
    name: 'MoonPay Commerce',
    author: 'MoonPay',
    authorHandle: '@moonpay',
    tag: 'Skill',
    category: 'other',
    description: 'Commerce toolkit for MoonPay merchants. Product catalog, checkout widget, and settlement management for crypto payments.',
    downloads: 22300,
    stars: 745,
    version: '3.0.0',
    installCommand: 'npm install @moonpay/commerce',
    usageExample: '> add products\n> embed checkout\n> manage settlement',
    detailedDescription: 'MoonPay Commerce provides end-to-end merchant tooling for crypto payments. Features product catalog management, embeddable checkout widgets, automated settlement processing, refund handling, and detailed transaction reporting dashboards.',
    featured: true,
  },
  {
    id: 'moonpay-official-moonpay-deposit',
    name: 'MoonPay Deposit',
    author: 'MoonPay',
    authorHandle: '@moonpay',
    tag: 'Skill',
    category: 'other',
    description: 'Deposit infrastructure for MoonPay. Fiat deposit methods, bank wire automation, and ACH/SEPA direct debit processing.',
    downloads: 18900,
    stars: 634,
    version: '2.5.0',
    installCommand: 'npm install @moonpay/deposit',
    usageExample: '> setup deposit method\n> process wire transfer\n> automate ACH',
    detailedDescription: 'MoonPay Deposit handles fiat-to-crypto deposit infrastructure. Supports bank wire automation, ACH and SEPA direct debit processing, instant card deposits, and deposit status tracking with real-time balance updates.',
  },
  {
    id: 'moonpay-official-moonpay-discover-tokens',
    name: 'MoonPay Discover Tokens',
    author: 'MoonPay',
    authorHandle: '@moonpay',
    tag: 'Skill',
    category: 'analytics',
    description: 'Token discovery and research via MoonPay. Trending tokens, new listing alerts, and fundamental analysis summaries.',
    downloads: 15600,
    stars: 512,
    version: '2.0.0',
    installCommand: 'npm install @moonpay/discover-tokens',
    usageExample: '> discover trending\n> set new listing alert\n> analyze fundamentals',
    detailedDescription: 'MoonPay Discover Tokens helps users find and research crypto assets. Features trending token discovery algorithms, new listing alerts with push notifications, fundamental analysis summaries, and portfolio impact simulations.',
    trending: true,
  },
  {
    id: 'moonpay-official-moonpay-export-data',
    name: 'MoonPay Export Data',
    author: 'MoonPay',
    authorHandle: '@moonpay',
    tag: 'Skill',
    category: 'tools',
    description: 'Data export and reporting for MoonPay. Transaction history exports, tax reporting formats, and custom report generation.',
    downloads: 13400,
    stars: 456,
    version: '1.8.0',
    installCommand: 'npm install @moonpay/export-data',
    usageExample: '> export transactions\n> generate tax report\n> create custom report',
    detailedDescription: 'MoonPay Export Data provides comprehensive data export capabilities. Generate transaction history in CSV/JSON formats, create tax-ready reports compatible with major software, and build custom reports with date range and filter options.',
  },
  {
    id: 'moonpay-official-moonpay-feedback',
    name: 'MoonPay Feedback',
    author: 'MoonPay',
    authorHandle: '@moonpay',
    tag: 'Skill',
    category: 'other',
    description: 'User feedback collection for MoonPay. Sentiment analysis, issue tracking, and customer satisfaction monitoring with automated response routing.',
    downloads: 8900,
    stars: 298,
    version: '1.5.0',
    installCommand: 'npm install @moonpay/feedback',
    usageExample: '> collect feedback\n> analyze sentiment\n> route to support',
    detailedDescription: 'MoonPay Feedback collects and processes user input with AI-powered sentiment analysis. Features automated issue categorization, customer satisfaction score tracking, response routing to appropriate support tiers, and trend analysis dashboards.',
  },
  {
    id: 'moonpay-official-moonpay-fund-polymarket',
    name: 'MoonPay Fund Polymarket',
    author: 'MoonPay',
    authorHandle: '@moonpay',
    tag: 'Skill',
    category: 'other',
    description: 'Direct Polymarket funding via MoonPay. Instant USDC deposit for prediction market participation with gasless onboarding.',
    downloads: 21200,
    stars: 712,
    version: '2.0.0',
    installCommand: 'npm install @moonpay/fund-polymarket',
    usageExample: '> deposit to Polymarket\n> buy outcome shares\n> withdraw winnings',
    detailedDescription: 'MoonPay Fund Polymarket provides seamless onboarding to prediction markets. Features direct USDC deposit to Polymarket wallets, gasless onboarding for new users, outcome share purchase automation, and winnings withdrawal back to bank accounts.',
    trending: true,
  },
  {
    id: 'moonpay-official-moonpay-hardware-wallet',
    name: 'MoonPay Hardware Wallet',
    author: 'MoonPay',
    authorHandle: '@moonpay',
    tag: 'Skill',
    category: 'tools',
    description: 'Hardware wallet integration for MoonPay. Ledger and Trezor support, secure key management, and offline transaction signing.',
    downloads: 18700,
    stars: 623,
    version: '2.5.0',
    installCommand: 'npm install @moonpay/hardware-wallet',
    usageExample: '> connect Ledger\n> sign offline\n> manage keys',
    detailedDescription: 'MoonPay Hardware Wallet integration supports Ledger and Trezor devices. Features secure key management with air-gapped signing, transaction validation on device screens, multi-account derivation path management, and firmware update notifications.',
  },
  {
    id: 'moonpay-official-moonpay-mcp',
    name: 'MoonPay MCP Server',
    author: 'MoonPay',
    authorHandle: '@moonpay',
    tag: 'Skill',
    category: 'tools',
    description: 'MCP server for MoonPay integrations. Buy crypto, check prices, and manage transactions via Model Context Protocol.',
    downloads: 24500,
    stars: 834,
    version: '3.0.0',
    installCommand: 'npm install @moonpay/mcp-server',
    usageExample: '> buy crypto via MCP\n> check live prices\n> manage transactions',
    detailedDescription: 'MoonPay MCP Server exposes payment capabilities via Model Context Protocol. Enables AI agents to execute crypto purchases, query live prices, manage transaction statuses, and handle wallet operations through standardized MCP tool interfaces.',
    featured: true,
  },
  {
    id: 'moonpay-official-moonpay-missions',
    name: 'MoonPay Missions',
    author: 'MoonPay',
    authorHandle: '@moonpay',
    tag: 'Skill',
    category: 'other',
    description: 'Gamified onboarding missions for MoonPay. Task completion rewards, referral tracking, and achievement badges with crypto rewards.',
    downloads: 16700,
    stars: 567,
    version: '2.0.0',
    installCommand: 'npm install @moonpay/missions',
    usageExample: '> start mission\n> track progress\n> claim reward',
    detailedDescription: 'MoonPay Missions gamifies user onboarding with achievement-based learning. Features task completion tracking, referral program management, achievement badge NFT minting, and crypto reward distribution for milestone completion.',
  },
  {
    id: 'moonpay-official-moonpay-prediction-market',
    name: 'MoonPay Prediction Markets',
    author: 'MoonPay',
    authorHandle: '@moonpay',
    tag: 'Skill',
    category: 'other',
    description: 'Prediction market integration for MoonPay. Market discovery, position management, and outcome settlement with fiat onramp.',
    downloads: 19800,
    stars: 678,
    version: '2.2.0',
    installCommand: 'npm install @moonpay/prediction-markets',
    usageExample: '> discover markets\n> manage positions\n> settle outcomes',
    detailedDescription: 'MoonPay Prediction Markets provides prediction market access with fiat onramps. Discover active markets across platforms, manage position sizing and exits, automate outcome settlement, and track portfolio performance across prediction markets.',
  },
  {
    id: 'moonpay-official-moonpay-price-alerts',
    name: 'MoonPay Price Alerts',
    author: 'MoonPay',
    authorHandle: '@moonpay',
    tag: 'Skill',
    category: 'analytics',
    description: 'Crypto price alerts via MoonPay. Threshold notifications, volatility alerts, and market movement triggers with multi-channel delivery.',
    downloads: 22300,
    stars: 745,
    version: '2.5.0',
    installCommand: 'npm install @moonpay/price-alerts',
    usageExample: '> set price alert\n> configure threshold\n> receive notification',
    detailedDescription: 'MoonPay Price Alerts delivers multi-channel crypto price notifications. Set custom threshold alerts, configure volatility-based triggers, receive push/email/SMS/Telegram notifications, and integrate alert data with automated trading actions.',
    trending: true,
  },
  {
    id: 'moonpay-official-moonpay-scout',
    name: 'MoonPay Scout',
    author: 'MoonPay',
    authorHandle: '@moonpay',
    tag: 'Skill',
    category: 'analytics',
    description: 'Market scouting tool for MoonPay. Opportunity detection, arbitrage tracking, and alpha signal aggregation across exchanges.',
    downloads: 13400,
    stars: 445,
    version: '1.8.0',
    installCommand: 'npm install @moonpay/scout',
    usageExample: '> scout opportunities\n> track arbitrage\n> get alpha signals',
    detailedDescription: 'MoonPay Scout provides market intelligence for active traders. Features cross-exchange arbitrage opportunity detection, alpha signal aggregation from multiple sources, momentum tracking, and automated opportunity alert delivery.',
  },
  {
    id: 'moonpay-official-moonpay-swap-tokens',
    name: 'MoonPay Token Swap',
    author: 'MoonPay',
    authorHandle: '@moonpay',
    tag: 'Skill',
    category: 'defi',
    description: 'In-app token swapping via MoonPay. Best-price routing, slippage protection, and multi-chain swap execution.',
    downloads: 28700,
    stars: 956,
    version: '3.0.0',
    installCommand: 'npm install @moonpay/swap-tokens',
    usageExample: '> swap ETH to USDC\n> find best route\n> execute multi-chain',
    detailedDescription: 'MoonPay Token Swap enables seamless in-app token exchanges. Features best-price routing across DEX aggregators, slippage protection with customizable tolerance, multi-chain swap execution, and real-time price impact estimation before confirmation.',
    featured: true,
    trending: true,
  },
  {
    id: 'moonpay-official-moonpay-trading-automation',
    name: 'MoonPay Trading Automation',
    author: 'MoonPay',
    authorHandle: '@moonpay',
    tag: 'Skill',
    category: 'trading',
    description: 'Automated trading strategies via MoonPay. DCA schedules, grid trading, and stop-loss automation with portfolio rebalancing.',
    downloads: 15600,
    stars: 534,
    version: '2.0.0',
    installCommand: 'npm install @moonpay/trading-automation',
    usageExample: '> setup DCA schedule\n> configure grid\n> set stop-loss',
    detailedDescription: 'MoonPay Trading Automation provides strategy execution for retail traders. Schedule DCA purchases, configure grid trading bots with adjustable spacing, automate stop-loss and take-profit orders, and execute periodic portfolio rebalancing.',
  },
  {
    id: 'moonpay-official-moonpay-upgrade',
    name: 'MoonPay Upgrade',
    author: 'MoonPay',
    authorHandle: '@moonpay',
    tag: 'Skill',
    category: 'tools',
    description: 'Account upgrade and verification flow for MoonPay. Tier progression, limit increases, and enhanced feature unlocks.',
    downloads: 11200,
    stars: 378,
    version: '2.0.0',
    installCommand: 'npm install @moonpay/upgrade',
    usageExample: '> check tier status\n> start upgrade\n> increase limits',
    detailedDescription: 'MoonPay Upgrade manages account tier progression and verification flows. Features automated KYC tier upgrades, purchase limit increase requests, enhanced feature unlocks upon tier completion, and document submission status tracking.',
  },
  {
    id: 'moonpay-official-moonpay-virtual-account',
    name: 'MoonPay Virtual Account',
    author: 'MoonPay',
    authorHandle: '@moonpay',
    tag: 'Skill',
    category: 'other',
    description: 'Virtual bank account for crypto onramp. IBAN generation, automatic conversion, and recurring deposit scheduling.',
    downloads: 17800,
    stars: 598,
    version: '2.2.0',
    installCommand: 'npm install @moonpay/virtual-account',
    usageExample: '> generate IBAN\n> setup auto-convert\n> schedule deposits',
    detailedDescription: 'MoonPay Virtual Account provides dedicated IBAN accounts for seamless crypto onramp. Features automatic fiat-to-crypto conversion upon deposit, recurring deposit scheduling, multi-currency account support, and real-time deposit notification webhooks.',
  },
  {
    id: 'moonpay-official-moonpay-x402',
    name: 'MoonPay x402',
    author: 'MoonPay',
    authorHandle: '@moonpay',
    tag: 'Skill',
    category: 'tools',
    description: 'MoonPay integration via x402 micropayments. Per-request payment processing, API billing, and usage-based pricing.',
    downloads: 13400,
    stars: 456,
    version: '1.5.0',
    installCommand: 'npm install @moonpay/x402',
    usageExample: '> init x402 client\n> process per-request\n> track usage billing',
    detailedDescription: 'MoonPay x402 provides micropayment-based access to MoonPay services. Features per-request USDC billing via x402 protocol, transparent usage tracking, automated invoicing, and granular API endpoint pricing with spend limit controls.',
  },
  {
    id: 'moonpay-official-myriad-prediction-markets',
    name: 'MoonPay Myriad Prediction Markets',
    author: 'MoonPay',
    authorHandle: '@moonpay',
    tag: 'Skill',
    category: 'other',
    description: 'Myriad prediction market platform via MoonPay. Market creation, liquidity provision, and outcome resolution with fiat access.',
    downloads: 12300,
    stars: 412,
    version: '1.8.0',
    installCommand: 'npm install @moonpay/myriad-prediction',
    usageExample: '> create market\n> provide liquidity\n> resolve outcome',
    detailedDescription: 'MoonPay Myriad Prediction Markets brings fiat-accessible prediction markets to users. Create custom markets, provide liquidity with automated market maker support, participate in outcome resolution voting, and withdraw winnings to bank accounts.',
  },
  {
    id: 'moonpay-official-shipp-sports-data',
    name: 'MoonPay Shipp Sports Data',
    author: 'MoonPay',
    authorHandle: '@moonpay',
    tag: 'Skill',
    category: 'analytics',
    description: 'Sports data and betting intelligence via MoonPay and Shipp. Live odds, match analytics, and prediction market correlation.',
    downloads: 8900,
    stars: 312,
    version: '1.5.0',
    installCommand: 'npm install @moonpay/shipp-sports',
    usageExample: '> get live odds\n> analyze match\n> correlate predictions',
    detailedDescription: 'MoonPay Shipp Sports Data provides sports betting intelligence. Access live odds from multiple bookmakers, detailed match analytics and player statistics, prediction market correlation analysis, and automated arbitrage detection across sports and crypto markets.',
  },
  {
    id: 'moonpay-official-thoughtproof-reasoning-check',
    name: 'MoonPay ThoughtProof Reasoning',
    author: 'MoonPay',
    authorHandle: '@moonpay',
    tag: 'Skill',
    category: 'other',
    description: 'AI reasoning validation for MoonPay decisions. Transaction logic verification, intent alignment, and decision audit trails.',
    downloads: 5600,
    stars: 198,
    version: '1.0.0',
    installCommand: 'npm install @moonpay/thoughtproof',
    usageExample: '> validate reasoning\n> check intent alignment\n> generate audit trail',
    detailedDescription: 'MoonPay ThoughtProof Reasoning validates AI agent payment decisions. Features transaction logic verification against stated intent, alignment scoring between agent actions and user preferences, and immutable decision audit trails for compliance.',
  },
  {
    id: 'mpp',
    name: 'MPP Payment Protocol',
    author: 'MPP Labs',
    authorHandle: '@mpp-labs',
    tag: 'Skill',
    category: 'other',
    description: 'Multi-party payment protocol for AI agents. Split payments, escrow arbitration, and conditional release with multi-sig.',
    downloads: 6700,
    stars: 267,
    version: '2.0.0',
    installCommand: 'npm install mpp-protocol',
    usageExample: '> create split payment\n> setup escrow\n> conditional release',
    detailedDescription: 'MPP Payment Protocol enables complex multi-party crypto transactions. Features percentage-based payment splitting, multi-sig escrow with arbitrator selection, conditional release triggers, and dispute resolution with automated fund distribution.',
  },
  {
    id: 'package',
    name: 'Package Payment Bundle',
    author: 'Package Protocol',
    authorHandle: '@package-protocol',
    tag: 'Skill',
    category: 'tools',
    description: 'Bundled payment solution for subscription packages. Tier management, prorated billing, and upgrade/downgrade automation.',
    downloads: 8900,
    stars: 345,
    version: '1.5.0',
    installCommand: 'npm install package-payment-bundle',
    usageExample: '> create package tier\n> handle prorated billing\n> process upgrade',
    detailedDescription: 'Package Payment Bundle manages complex subscription billing scenarios. Features tiered package creation, prorated billing calculation for mid-cycle changes, automated upgrade and downgrade processing, and grandfathered pricing preservation.',
  },
  {
    id: 'parrot-celo-payments',
    name: 'Parrot Celo Payments',
    author: 'Parrot Protocol',
    authorHandle: '@parrot-protocol',
    tag: 'Skill',
    category: 'other',
    description: 'Celo-optimized payment infrastructure. Mobile-first transfers, stablecoin stability, and ultra-low gas costs for emerging markets.',
    downloads: 7800,
    stars: 312,
    version: '2.0.0',
    installCommand: 'npm install @parrot/celo-payments',
    usageExample: '> send Celo payment\n> use cUSD stablecoin\n> optimize for mobile',
    detailedDescription: 'Parrot Celo Payments leverages Celo blockchain for emerging market payments. Features mobile-first UX optimized for low-bandwidth, cUSD stablecoin with automatic stability mechanisms, ultra-low transaction costs, and phone number-based address resolution.',
  },
  {
    id: 'pulse-remit',
    name: 'Pulse Remittance',
    author: 'Pulse Network',
    authorHandle: '@pulse-network',
    tag: 'Skill',
    category: 'other',
    description: 'Cross-border remittance on Pulse Network. Low-fee international transfers, FX rate locking, and recipient cash-out automation.',
    downloads: 11200,
    stars: 445,
    version: '2.5.0',
    installCommand: 'npm install pulse-remit',
    usageExample: '> send remittance\n> lock FX rate\n> automate cash-out',
    detailedDescription: 'Pulse Remittance provides affordable cross-border money transfers. Features low-fee international transfers via Pulse Network, FX rate locking for up to 48 hours, automated recipient cash-out to local bank accounts or mobile money wallets.',
    trending: true,
  },
  {
    id: 'remittance-agent',
    name: 'Remittance Agent',
    author: 'RemittanceDAO',
    authorHandle: '@remittance-dao',
    tag: 'Skill',
    category: 'other',
    description: 'Autonomous remittance agent for AI systems. Route optimization, compliance checks, and settlement orchestration across corridors.',
    downloads: 6700,
    stars: 278,
    version: '1.8.0',
    installCommand: 'npm install remittance-agent',
    usageExample: '> optimize remittance route\n> run compliance check\n> orchestrate settlement',
    detailedDescription: 'Remittance Agent autonomously manages cross-border transfers. Features AI-powered route optimization across payment corridors, automated compliance screening for sender and receiver, settlement orchestration with fallback providers, and real-time corridor status monitoring.',
  },
  {
    id: 'tempo',
    name: 'Tempo Payment Network',
    author: 'Tempo Labs',
    authorHandle: '@tempo-labs',
    tag: 'Skill',
    category: 'other',
    description: 'High-frequency payment network for AI agents. Micro-transaction batching, latency optimization, and throughput scaling.',
    downloads: 8900,
    stars: 356,
    version: '2.0.0',
    installCommand: 'npm install tempo-payment',
    usageExample: '> batch micro-txs\n> optimize latency\n> scale throughput',
    detailedDescription: 'Tempo Payment Network is built for high-frequency AI agent transactions. Features intelligent micro-transaction batching, sub-100ms latency optimization, horizontal throughput scaling, and congestion-aware fee management for peak load periods.',
  },
  {
    id: 'titan-email-remittance',
    name: 'Titan Email Remittance',
    author: 'Titan Protocol',
    authorHandle: '@titan-protocol',
    tag: 'Skill',
    category: 'other',
    description: 'Email-based crypto remittance via Titan. Send funds to any email address, recipient claims via secure link, and fiat off-ramp.',
    downloads: 12300,
    stars: 487,
    version: '2.0.0',
    installCommand: 'npm install titan-email-remit',
    usageExample: '> send to email\n> generate claim link\n> off-ramp to fiat',
    detailedDescription: 'Titan Email Remittance enables crypto transfers to any email address. Features secure claim link generation with expiration, recipient wallet creation on first claim, automatic fiat off-ramp for non-crypto recipients, and transaction status email notifications.',
    featured: true,
  },
  {
    id: 'toppa-agent',
    name: 'Toppa Payment Agent',
    author: 'Toppa',
    authorHandle: '@toppa',
    tag: 'Skill',
    category: 'other',
    description: 'Payment agent for Toppa financial network. Multi-currency accounts, instant settlement, and invoice automation.',
    downloads: 7800,
    stars: 312,
    version: '1.5.0',
    installCommand: 'npm install toppa-agent',
    usageExample: '> open multi-currency\n> settle instantly\n> auto-generate invoice',
    detailedDescription: 'Toppa Payment Agent manages multi-currency payment operations. Features instant settlement across supported currencies, automated invoice generation with payment link embedding, recurring payment scheduling, and real-time balance reconciliation.',
  },
  {
    id: 'toppa-finance-agent',
    name: 'Toppa Finance Agent',
    author: 'Toppa',
    authorHandle: '@toppa',
    tag: 'Skill',
    category: 'other',
    description: 'Financial operations agent for Toppa. Treasury management, cash flow forecasting, and automated reconciliation with crypto support.',
    downloads: 6700,
    stars: 278,
    version: '2.0.0',
    installCommand: 'npm install toppa-finance-agent',
    usageExample: '> manage treasury\n> forecast cash flow\n> auto-reconcile',
    detailedDescription: 'Toppa Finance Agent provides treasury and financial operations automation. Features multi-account treasury management, AI-powered cash flow forecasting, automated bank and crypto reconciliation, and financial report generation with ERP integration.',
  },
  {
    id: 'toppa-fintech',
    name: 'Toppa Fintech Suite',
    author: 'Toppa',
    authorHandle: '@toppa',
    tag: 'Skill',
    category: 'other',
    description: 'Comprehensive fintech toolkit for Toppa. Banking API, card issuance, and payment orchestration with crypto-fiat bridging.',
    downloads: 15600,
    stars: 534,
    version: '3.0.0',
    installCommand: 'npm install toppa-fintech',
    usageExample: '> use banking API\n> issue virtual card\n> bridge crypto-fiat',
    detailedDescription: 'Toppa Fintech Suite delivers a full-stack financial toolkit. Features banking API integration for account management, virtual and physical card issuance with spending controls, payment orchestration across rails, and seamless crypto-to-fiat bridging with competitive exchange rates.',
    featured: true,
  },
  {
    id: 'toppa-payments-agent',
    name: 'Toppa Payments Agent',
    author: 'Toppa',
    authorHandle: '@toppa',
    tag: 'Skill',
    category: 'other',
    description: 'Dedicated payment processing agent for Toppa. Checkout optimization, fraud prevention, and payment method management.',
    downloads: 11200,
    stars: 445,
    version: '2.5.0',
    installCommand: 'npm install toppa-payments-agent',
    usageExample: '> optimize checkout\n> run fraud check\n> manage methods',
    detailedDescription: 'Toppa Payments Agent specializes in payment processing optimization. Features intelligent checkout flow optimization, real-time fraud prevention with ML scoring, payment method preference learning, and automatic retry logic for failed transactions.',
  },
  {
    id: 'toppa-payments',
    name: 'Toppa Payments',
    author: 'Toppa',
    authorHandle: '@toppa',
    tag: 'Skill',
    category: 'other',
    description: 'Core payment infrastructure for Toppa. Multi-rail processing, settlement management, and merchant onboarding with compliance.',
    downloads: 18900,
    stars: 623,
    version: '3.5.0',
    installCommand: 'npm install toppa-payments',
    usageExample: '> process payment\n> manage settlement\n> onboard merchant',
    detailedDescription: 'Toppa Payments is the core payment processing layer. Supports multi-rail processing across cards, bank transfers, and crypto, automated settlement management with configurable schedules, streamlined merchant onboarding with KYC automation, and compliance reporting.',
    trending: true,
  },
  {
    id: 'toppa',
    name: 'Toppa Core',
    author: 'Toppa',
    authorHandle: '@toppa',
    tag: 'Skill',
    category: 'other',
    description: 'Core Toppa platform SDK. Account management, identity verification, and base API access for all Toppa services.',
    downloads: 24500,
    stars: 834,
    version: '4.0.0',
    installCommand: 'npm install toppa-core',
    usageExample: '> create account\n> verify identity\n> access APIs',
    detailedDescription: 'Toppa Core SDK provides foundational access to the Toppa platform. Features account creation and management, identity verification workflows, base API authentication and rate limiting, webhook configuration, and service discovery for all Toppa modules.',
    featured: true,
  },
  {
    id: 'x402-agent-api',
    name: 'x402 Agent API',
    author: 'x402 Foundation',
    authorHandle: '@x402',
    tag: 'Skill',
    category: 'tools',
    description: 'x402 API access for AI agents. Programmatic micropayments, content monetization, and API billing with per-request pricing.',
    downloads: 13400,
    stars: 534,
    version: '2.0.0',
    installCommand: 'npm install @x402/agent-api',
    usageExample: '> create micropayment\n> monetize content\n> bill per request',
    detailedDescription: 'x402 Agent API provides programmatic access to x402 micropayment infrastructure. Enable content monetization with per-request pricing, automated API billing with usage tracking, and agent-to-agent payment flows with transparent settlement on Base.',
  },
  {
    id: 'x402-agent-marketplace',
    name: 'x402 Agent Marketplace',
    author: 'x402 Foundation',
    authorHandle: '@x402',
    tag: 'Skill',
    category: 'other',
    description: 'Marketplace for AI agent services powered by x402. List capabilities, discover agents, and pay per use with USDC.',
    downloads: 8900,
    stars: 356,
    version: '1.5.0',
    installCommand: 'npm install @x402/agent-marketplace',
    usageExample: '> list agent capability\n> discover services\n> pay per use',
    detailedDescription: 'x402 Agent Marketplace enables service exchange between AI agents. List agent capabilities with pricing, discover and compare services from other agents, execute micropayment transactions per use with USDC settlement, and build reputation through ratings.',
  },
  {
    id: 'x402-breeze-api',
    name: 'x402 Breeze API',
    author: 'x402 Foundation',
    authorHandle: '@x402',
    tag: 'Skill',
    category: 'tools',
    description: 'Lightweight x402 API with minimal overhead. Fast micropayments, zero-config setup, and instant content access.',
    downloads: 11200,
    stars: 445,
    version: '1.8.0',
    installCommand: 'npm install @x402/breeze-api',
    usageExample: '> quick micropayment\n> zero-config setup\n> instant access',
    detailedDescription: 'x402 Breeze API offers a lightweight micropayment solution. Features sub-second payment confirmation, zero-configuration setup with sane defaults, instant content access after payment verification, and minimal integration overhead for developers.',
    trending: true,
  },
  {
    id: 'x402-cli',
    name: 'x402 CLI',
    author: 'x402 Foundation',
    authorHandle: '@x402',
    tag: 'Skill',
    category: 'tools',
    description: 'Command-line interface for x402 micropayments. Payment testing, gateway management, and analytics from the terminal.',
    downloads: 15600,
    stars: 567,
    version: '2.0.0',
    installCommand: 'npm install -g x402-cli',
    usageExample: '> x402 pay 0.01 USDC\n> x402 gateway list\n> x402 analytics',
    detailedDescription: 'x402 CLI provides terminal-based control of micropayment operations. Execute test payments, manage gateway configurations, view real-time analytics, export transaction logs, and automate payment workflows with shell scripts and cron jobs.',
  },
  {
    id: 'x402-client',
    name: 'x402 Client',
    author: 'x402 Foundation',
    authorHandle: '@x402',
    tag: 'Skill',
    category: 'tools',
    description: 'Universal x402 payment client for browsers and Node.js. Wallet connection, payment signing, and receipt verification.',
    downloads: 22300,
    stars: 745,
    version: '3.0.0',
    installCommand: 'npm install @x402/client',
    usageExample: '> connect wallet\n> sign payment\n> verify receipt',
    detailedDescription: 'x402 Client is a universal micropayment client for web and server environments. Features seamless wallet connection via EIP-1193, automated payment signing and broadcasting, cryptographic receipt verification, and support for all EVM-compatible chains.',
    featured: true,
  },
  {
    id: 'x402-deploy',
    name: 'x402 Deploy',
    author: 'x402 Foundation',
    authorHandle: '@x402',
    tag: 'Skill',
    category: 'tools',
    description: 'Deployment toolkit for x402 payment infrastructure. Gateway setup, contract deployment, and monitoring configuration.',
    downloads: 8900,
    stars: 312,
    version: '1.5.0',
    installCommand: 'npm install @x402/deploy',
    usageExample: '> deploy gateway\n> setup contracts\n> configure monitoring',
    detailedDescription: 'x402 Deploy streamlines payment infrastructure setup. Features one-command gateway deployment across chains, automated smart contract deployment with parameter validation, monitoring and alerting configuration, and environment-based config management.',
  },
  {
    id: 'x402-passthrough',
    name: 'x402 Passthrough',
    author: 'x402 Foundation',
    authorHandle: '@x402',
    tag: 'Skill',
    category: 'tools',
    description: 'Transparent x402 payment middleware. Request interception, payment gating, and content serving with zero backend changes.',
    downloads: 13400,
    stars: 456,
    version: '2.0.0',
    installCommand: 'npm install @x402/passthrough',
    usageExample: '> setup middleware\n> intercept requests\n> gate content',
    detailedDescription: 'x402 Passthrough acts as transparent middleware for monetizing existing APIs and content. Intercepts incoming requests, handles payment verification, gates content access, and passes through to original backend with zero code changes required.',
  },
  {
    id: 'x402-payment-tron',
    name: 'x402 Payment Tron',
    author: 'x402 Foundation',
    authorHandle: '@x402',
    tag: 'Skill',
    category: 'other',
    description: 'TRON blockchain support for x402 micropayments. TRX and USDT-TRC20 payment processing with high throughput.',
    downloads: 7800,
    stars: 298,
    version: '1.0.0',
    installCommand: 'npm install @x402/payment-tron',
    usageExample: '> pay with TRX\n> use USDT-TRC20\n> process high throughput',
    detailedDescription: 'x402 Payment Tron extends micropayments to the TRON ecosystem. Supports TRX and USDT-TRC20 payment processing, leverages TRON high throughput for sub-second confirmation, and integrates with TRON wallet providers for seamless UX.',
  },
  {
    id: 'x402-paywall-kit',
    name: 'x402 Paywall Kit',
    author: 'x402 Foundation',
    authorHandle: '@x402',
    description: 'Ready-to-use paywall components for x402. Article gating, video access control, and subscription management with drop-in UI.',
    downloads: 15600,
    stars: 534,
    version: '2.0.0',
    installCommand: 'npm install @x402/paywall-kit',
    usageExample: '> add article paywall\n> gate video access\n> manage subscriptions',
    detailedDescription: 'x402 Paywall Kit provides production-ready paywall components. Features article and content gating with customizable tiers, video access control with timestamp-based billing, subscription management with trial periods, and drop-in React/Vue components.',
    tag: 'Skill',
    category: 'tools',
    trending: true,
  },
  {
    id: 'x402-private-search',
    name: 'x402 Private Search',
    author: 'x402 Foundation',
    authorHandle: '@x402',
    tag: 'Skill',
    category: 'other',
    description: 'Privacy-preserving search with x402 micropayments. Anonymous queries, encrypted results, and pay-per-search billing.',
    downloads: 6700,
    stars: 267,
    version: '1.5.0',
    installCommand: 'npm install @x402/private-search',
    usageExample: '> search anonymously\n> encrypt results\n> pay per search',
    detailedDescription: 'x402 Private Search combines search functionality with privacy and micropayments. Features anonymous query submission via mix networks, end-to-end encrypted result delivery, per-search USDC billing without identity linkage, and zero-knowledge query validation.',
  },
  {
    id: 'x402-skill',
    name: 'x402 Skill Template',
    author: 'x402 Foundation',
    authorHandle: '@x402',
    tag: 'Skill',
    category: 'tools',
    description: 'Skill template for building x402-compatible AI agent capabilities. Payment integration boilerplate, receipt handling, and error recovery.',
    downloads: 18900,
    stars: 623,
    version: '2.0.0',
    installCommand: 'npm install @x402/skill-template',
    usageExample: '> init x402 skill\n> integrate payment\n> handle receipts',
    detailedDescription: 'x402 Skill Template accelerates agent capability development. Includes payment integration boilerplate with best practices, automatic receipt handling and storage, payment failure recovery flows, and example implementations for common agent use cases.',
    featured: true,
  },
  {
    id: 'x402',
    name: 'x402 Protocol',
    author: 'x402 Foundation',
    authorHandle: '@x402',
    tag: 'Skill',
    category: 'tools',
    description: 'Core x402 micropayment protocol implementation. Payment headers, verification logic, and settlement orchestration for the web.',
    downloads: 34500,
    stars: 1234,
    version: '4.0.0',
    installCommand: 'npm install x402',
    usageExample: '> create payment header\n> verify payment\n> orchestrate settlement',
    detailedDescription: 'x402 is the core micropayment protocol for the web. Implements HTTP 402 payment headers, cryptographic payment verification, settlement orchestration across EVM chains, gateway discovery, and standardized receipt formats for content and API monetization.',
    featured: true,
    trending: true,
  },
  {
    id: 'x402watch',
    name: 'x402Watch',
    author: 'x402 Foundation',
    authorHandle: '@x402',
    tag: 'Skill',
    category: 'analytics',
    description: 'Monitoring and analytics for x402 micropayments. Transaction dashboards, gateway health checks, and revenue reporting.',
    downloads: 11200,
    stars: 445,
    version: '2.0.0',
    installCommand: 'npm install x402watch',
    usageExample: '> view dashboard\n> check gateway health\n> generate revenue report',
    detailedDescription: 'x402Watch provides comprehensive monitoring for x402 payment infrastructure. Features real-time transaction dashboards, gateway health and uptime monitoring, automated revenue reporting with export options, anomaly detection, and alerting integration with PagerDuty and Slack.',
  },
];